import { Controller } from "@hotwired/stimulus";

// The logo of the sender sits over its initials: a logo that cannot be
// loaded is taken away, and the initials show.
export default class extends Controller {
  static targets = ["image"];

  imageTargetConnected(image) {
    // The error may have fired before the controller was there to hear it.
    if (image.complete && image.naturalWidth === 0) image.remove();
  }

  drop(event) {
    event.target.remove();
  }
}
